module.exports = __webpack_public_path__ + "img/zip.a6f41813.svg";